import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertTypePayment'
})
export class ConvertTypePaymentPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if(value == "credit") {
      return "Crédito";
    } else if(value == "debit") {
      return "Débito";
    }
    return null;
  }

}
